export default class Personal {
  #userView;
  #deliveryView;
  #entityView;

  constructor(userView, deliveryView, entityView) {
    this.#userView = userView;
    this.#deliveryView = deliveryView;
    this.#entityView = entityView;

    this.handlePersonalOpenModalButtonClick = this.handlePersonalOpenModalButtonClick.bind(this);
    this.handleDeliveryOpenModalButtonClick = this.handleDeliveryOpenModalButtonClick.bind(this);
    this.handleEntityOpenModalButtonClick = this.handleEntityOpenModalButtonClick.bind(this);
    this.handleUserCloseModalButtonClick = this.handleUserCloseModalButtonClick.bind(this);
    this.handleDeliveryCloseModalButtonClick = this.handleDeliveryCloseModalButtonClick.bind(this);
    this.handleEntityCloseModalButtonClick = this.handleEntityCloseModalButtonClick.bind(this);
    this.handleUserFormSubmit = this.handleUserFormSubmit.bind(this);
    this.handleDeliveryFormSubmit = this.handleDeliveryFormSubmit.bind(this);
    this.handleEntityFormSubmit = this.handleEntityFormSubmit.bind(this);
    this.handleDeliveryFormChange = this.handleDeliveryFormChange.bind(this);
    this.handleEntityFormChange = this.handleEntityFormChange.bind(this);
  }

  init() {
    this.#userView.setOpenModalButtonClickHandler(this.handlePersonalOpenModalButtonClick);
    this.#userView.setFormSubmitHandler(this.handleUserFormSubmit);
    this.#deliveryView.setOpenModalButtonClickHandler(this.handleDeliveryOpenModalButtonClick);
    this.#deliveryView.setFormSubmitHandler(this.handleDeliveryFormSubmit);
    this.#deliveryView.setFormChangeHandler(this.handleDeliveryFormChange);
    this.#entityView.setOpenModalButtonClickHandler(this.handleEntityOpenModalButtonClick);
    this.#entityView.setFormSubmitHandler(this.handleEntityFormSubmit);
    this.#entityView.setFormChangeHandler(this.handleEntityFormChange);
  }

  handlePersonalOpenModalButtonClick(evt) {
    evt.preventDefault();
    this.#userView.showForm();
    this.#userView.setCloseButtonClickHandler(this.handleUserCloseModalButtonClick);
  }

  handleDeliveryOpenModalButtonClick(evt) {
    evt.preventDefault();
    this.#deliveryView.showForm();
    this.#deliveryView.setCloseButtonClickHandler(this.handleDeliveryCloseModalButtonClick);
  }

  handleEntityOpenModalButtonClick(evt) {
    evt.preventDefault();
    this.#entityView.showForm();
    this.#entityView.setCloseButtonClickHandler(this.handleEntityCloseModalButtonClick);
  }

  handleUserFormSubmit(evt) {
    this.#userView.fillTextElements();
    this.#userView.submitForm(evt);
  }

  handleDeliveryFormSubmit(evt) {
    this.#deliveryView.fillTextElements();
    this.#deliveryView.submitForm(evt);
  }

  handleEntityFormSubmit(evt) {
    this.#entityView.fillTextElements();
    this.#entityView.submitForm(evt);
  }

  handleUserCloseModalButtonClick() {
    this.#userView.hideForm();
  }

  handleDeliveryCloseModalButtonClick() {
    this.#deliveryView.hideForm();
  }

  handleEntityCloseModalButtonClick() {
    this.#entityView.hideForm();
  }

  handleDeliveryFormChange(evt) {
    this.#deliveryView.changeRadioValue(evt);
  }

  handleEntityFormChange(evt) {
    this.#entityView.changeRadioValue(evt);
  }
}
